export const AGE_MAX = 71
